module.exports = __webpack_public_path__ + "static/media/touch-loader.d9323358.less";


//////////////////
// WEBPACK FOOTER
// ./~/react-touch-loader/lib/touch-loader.less
// module id = 665
// module chunks = 0